import React from 'react';

const badges = [
  { id: 'badge-1', emoji: '🍍', name: 'Pineapple Hunter', desc: 'Found 10 hidden pineapples', rarity: 'Common' },
  { id: 'badge-2', emoji: '🚙', name: 'Blueberry Survivor', desc: 'Completed all car challenge rounds', rarity: 'Uncommon' },
  { id: 'badge-3', emoji: '🔮', name: 'Fake Psychic', desc: 'Achieved 90%+ on Quote or Not', rarity: 'Rare' },
  { id: 'badge-4', emoji: '💬', name: 'Quote Master', desc: 'Identified 50 authentic quotes', rarity: 'Uncommon' },
  { id: 'badge-5', emoji: '🔍', name: 'Memory Detective', desc: 'Perfect score on Observation', rarity: 'Rare' },
  { id: 'badge-6', emoji: '✅', name: 'Case Closed', desc: 'Finished all case file sets', rarity: 'Epic' },
  { id: 'badge-7', emoji: '📼', name: '80s Reference Expert', desc: 'Identified 25 pop culture refs', rarity: 'Uncommon' },
  { id: 'badge-8', emoji: '🥜', name: 'Snack-Based Deduction', desc: 'Won a round while on a food theme', rarity: 'Legendary' },
];

const rarityColors: Record<string, string> = {
  Common: 'text-muted-foreground',
  Uncommon: 'text-secondary',
  Rare: 'text-info',
  Epic: 'text-primary',
  Legendary: 'text-warning',
};

const xpActions = [
  { id: 'xp-1', action: 'Correct trivia answer', xp: '+10 XP', icon: '✓' },
  { id: 'xp-2', action: 'Perfect round score', xp: '+50 XP', icon: '⭐' },
  { id: 'xp-3', action: 'Daily challenge completed', xp: '+75 XP', icon: '🎯' },
  { id: 'xp-4', action: 'First place in leaderboard', xp: '+200 XP', icon: '🏆' },
  { id: 'xp-5', action: 'Badge earned', xp: '+100 XP', icon: '🏅' },
  { id: 'xp-6', action: 'Login streak (7 days)', xp: '+150 XP', icon: '🔥' },
];

export default function XPBadgeSection() {
  return (
    <section id="xp-system" className="py-24 px-6 max-w-screen-xl mx-auto">
      <div className="text-center mb-16">
        <p className="text-xs font-semibold uppercase tracking-widest text-primary mb-3">Progression System</p>
        <h2 className="text-hero-md font-extrabold text-foreground mb-4">
          Earn XP. Collect Badges.<br />
          <span className="gradient-text-primary">Climb the Ranks.</span>
        </h2>
        <p className="text-muted-foreground text-lg max-w-xl mx-auto">
          Every correct answer, perfect round, and daily challenge builds your detective reputation.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        {/* XP actions */}
        <div>
          <h3 className="text-base font-bold text-foreground mb-5 flex items-center gap-2">
            <span className="w-6 h-6 rounded-md bg-primary/15 flex items-center justify-center text-sm">⚡</span>
            How You Earn XP
          </h3>
          <div className="space-y-2">
            {xpActions.map((action) => (
              <div key={action.id} className="flex items-center gap-4 p-3.5 bg-card border border-border rounded-xl hover:border-primary/30 transition-all duration-150">
                <span className="text-lg w-7 text-center">{action.icon}</span>
                <span className="flex-1 text-sm text-foreground font-medium">{action.action}</span>
                <span className="text-sm font-bold text-primary font-mono-data">{action.xp}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Badges grid */}
        <div>
          <h3 className="text-base font-bold text-foreground mb-5 flex items-center gap-2">
            <span className="w-6 h-6 rounded-md bg-primary/15 flex items-center justify-center text-sm">🏅</span>
            Collectible Badges — Psych World
          </h3>
          <div className="grid grid-cols-2 gap-3">
            {badges.map((badge) => (
              <div
                key={badge.id}
                className="bg-card border border-border rounded-xl p-4 hover:border-primary/30 hover:bg-primary/5 transition-all duration-150 group cursor-default"
              >
                <div className="flex items-start gap-3">
                  <span className="text-2xl">{badge.emoji}</span>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-bold text-foreground truncate">{badge.name}</p>
                    <p className="text-[11px] text-muted-foreground leading-tight mt-0.5">{badge.desc}</p>
                    <p className={`text-[10px] font-semibold mt-1.5 ${rarityColors[badge.rarity]}`}>{badge.rarity}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}